import React, { PureComponent } from "react";

export class FlexBlock extends PureComponent {
  render() {
    const { text, value,unit,clW } = this.props;
    return (
      <div className={ `flex flex-col items-center ${clW}` }>
        <span className="subtext">{ text }</span>
        <span className="text-xl font-semibold textCor py-1">{ value }</span>
        <span className="subtext">{ unit }</span>
      </div>
    );
  }
}
